import { render, staticRenderFns } from "./MobileFormMenu.vue?vue&type=template&id=c2331130"
import script from "./MobileFormMenu.vue?vue&type=script&lang=js"
export * from "./MobileFormMenu.vue?vue&type=script&lang=js"
import style0 from "./MobileFormMenu.vue?vue&type=style&index=0&id=c2331130&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports